module.exports = __webpack_public_path__ + "static/media/packed_solution.28280814.gif";